import axios from "axios";

const api = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Pour envoyer les cookies
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  console.log("Intercepteur API - Token trouvé:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log("Intercepteur API - Headers après ajout:", config.headers);
  } else {
    console.log("Intercepteur API - Pas de token trouvé dans localStorage");
  }
  return config;
});

// Referral API methods
export const referralAPI = {
  validate: (code, email, phone) => api.get(`/referral/validate/${code}`, { params: { email, phone } }),
  getMyCode: () => api.get('/referral/my-code'),
  getCodeByEmail: (email) => api.get('/referral/code-by-email', { params: { email } }),
  use: (code, userEmail, userPhone) => api.post('/referral/use', { code, userEmail, userPhone })
};

// Wallet API methods
export const walletAPI = {
  sendOTP: (referralCode, email, phone) => api.post('/wallet/send-otp', { referralCode, email, phone }),
  verifyOTP: (referralCode, email, phone, otp) => api.post('/wallet/verify-otp', { referralCode, email, phone, otp }),
  getBalance: () => api.get('/wallet/balance'),
  getBalanceByEmail: (email, phone) => api.get('/wallet/balance-by-email', { params: { email, phone } }),
  getReorderDiscounts: (email, phone) => api.get('/wallet/reorder-discounts', { params: { email, phone } }),
  apply: (userId, amount, orderReference) => api.post('/wallet/apply', { userId, amount, orderReference })
};

// Settings API methods
export const settingsAPI = {
  getReferralSettings: () => api.get('/back-office/settings/referral'),
  updateReferralSettings: (settings) => api.put('/back-office/settings/referral', settings)
};

export default api;
